import { render, staticRenderFns } from "./OrgViewInfoCard.vue?vue&type=template&id=0f8f90c4&"
import script from "./OrgViewInfoCard.vue?vue&type=script&lang=js&"
export * from "./OrgViewInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports